import styled from '@emotion/styled';
import CircleIcon from '@mui/icons-material/Circle';
import { useDroppable } from '@dnd-kit/core';
import { Typography } from '@mui/material';
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';

import { FormationTheme, PitchPosition, Position, Team } from '../types';
import { shirts } from '../config/shirts';

const Wrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'position',
})<Partial<PitchPositionItemProps>>(({ position }) => {
  return {
    position: 'absolute',
    left: position?.x,
    top: position?.y,
  };
});

const PositionWrapper = styled('div')({
  positin: 'relative',
});

type PitchPositionItemProps = {
  team: Team;
  position: PitchPosition;
  theme?: FormationTheme;
};

const PlayerHead = ({ isOver }: { isOver: boolean }) => (
  <>
    {isOver && (
      <EmojiEmotionsIcon
        sx={{
          fontSize: 18,
          color: '#aa00ff',
          position: 'absolute',
          top: -10,
          left: '50%',
          transform: 'translate(-49%, 0%)',
        }}
      />
    )}

    {!isOver && (
      <CircleIcon
        sx={{
          fontSize: 18,
          color: isOver ? '#fff' : '#212121',
          position: 'absolute',
          top: -10,
          left: '50%',
          transform: 'translate(-49%, 0%)',
        }}
      />
    )}
  </>
);

const PositionShirt = ({
  isOver,
  position,
  img,
  style,
}: {
  isOver: boolean;
  position: Position;
  img: string;
  style?: (isOver: boolean) => React.CSSProperties;
}) => (
  <PositionWrapper>
    <img
      src={img}
      alt="shirt"
      style={{
        width: 50,
        filter: isOver
          ? 'sepia(1) hue-rotate(200deg) brightness(0.8) saturate(2)'
          : 'none',
      }}
    />
    <PlayerHead isOver={isOver} />
    <Typography
      variant="body2"
      style={{
        fontSize: 12,
        position: 'absolute',
        top: '45%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: isOver ? '#fff' : '#000',
        ...(style ? style(isOver) : {}),
      }}
    >
      {position}
    </Typography>
  </PositionWrapper>
);

export const PitchPositionItem = ({
  team,
  position,
  theme,
}: PitchPositionItemProps) => {
  const { isOver, setNodeRef } = useDroppable({
    id: `${team.name}-${position.position}`,
    data: {
      team,
      position: position.position,
    },
  });

  const style = {
    marginLeft: -25,
    with: 50,
    height: 50,
  };

  const formationTheme = theme || FormationTheme.ShirtOrange;
  let shirt =
    shirts.find((shirt) => shirt.theme === formationTheme) || shirts[0];

  return (
    <Wrapper position={position} ref={setNodeRef} style={style}>
      <PositionShirt
        isOver={isOver}
        position={position.position}
        img={shirt.img}
        style={(isOver) => ({
          color: isOver ? shirt.textColorDragOver : shirt.textColor,
        })}
      />
    </Wrapper>
  );
};
